export const SUPPORTS_OBJECT_GET_OWN_PROPERTY_DESCRIPTORS = "getOwnPropertyDescriptors" in Object;
